import React from 'react';
import classes from './Nest.module.css';
import Nest from 'assets/images/nest.svg';
import SendFeedback from 'components/UI/SendFeedback/SendFeedback';

const Growth = () => {
  return (
    <div className={classes.Container}>
      <h1 className={classes.ComingSoon}>Coming Soon</h1>
      <div className={classes.NestContainer}>
        <h1>Nest</h1>
        <p>Build and grow networks of support for a good life</p>
        <img src={Nest} alt="Nest" />
      </div>
      <SendFeedback />
    </div>
  );
};

export default Growth;
